import { IStore } from "../interfaces";
import { translations as allTranslations } from "../translations";

export const setLanguage = (store: IStore, language: string) => {
  const translations = allTranslations[language];

  store.setState({ ...store.state, translations });
};

export const setCountry = (store: IStore, country: string) => {
  store.setState({ ...store.state, country });
};

const actions = { setLanguage, setCountry };
export default actions;
